/**
 * KPI 总览「事件」筛选区中英文文案默认（可与 pageConfig.filters[].kpiEventFilterLanguage 合并覆盖）
 */

/** 与 pageConfig `kpiEventFilterLanguage` 对齐；主/次提示可用 `\n` 换行 */
export interface IKpiEventFilterLanguage {
  checkboxLabelZh: string;
  checkboxLabelEn: string;
  /** 吸顶摘要：开启态值（与 checkbox 语义一致，可单独覆盖文案） */
  stickyValueOnZh?: string;
  stickyValueOnEn?: string;
  stickyValueOffZh?: string;
  stickyValueOffEn?: string;
  /** 主气泡（Checkbox 旁） */
  primaryTipsZh: string;
  primaryTipsEn: string;
  /** 次气泡（设置图标旁） */
  secondaryTipsZh: string;
  secondaryTipsEn: string;
}

export const KPI_EVENT_FILTER_LANGUAGE_DEFAULTS: IKpiEventFilterLanguage = {
  checkboxLabelZh: '显示 事件',
  checkboxLabelEn: 'Show Events',
  stickyValueOnZh: '显示',
  stickyValueOnEn: 'Show',
  stickyValueOffZh: '隐藏',
  stickyValueOffEn: 'Hide',
  primaryTipsZh:
    '勾选后，当天发生的运营事件将显示在对应日期的图表上方。\n趋势图如未展示事件，表示当前所选时间范围未录入事件。\n新增事件请联系 sallyxue@tencent.com。',
  primaryTipsEn:
    'After checking the box, operational events that occur on the same day will be displayed above the chart corresponding to the date.\nIf the chart does not display any events, it indicates that no events have been entered for the selected time period.\nTo add new events, please contact sallyxue@tencent.com.',
  secondaryTipsZh:
    '所选事件过多时，可能导致图表上事件显示不全，请点击进入【事件设置】减少当前所选事件',
  secondaryTipsEn:
    'When too many events are selected, some may not be fully displayed on the chart due to space constraints. Please click on [Event Settings] to reduce the selected events',
};
